var $35da740d59af89ba$exports = {};
function $35da740d59af89ba$var$clearElements(error_message = '') {
    document.getElementById("error_message").innerHTML = error_message;
    document.getElementById("addresses").innerHTML = '';
    document.getElementById("address-details").innerHTML = "";
    //document.getElementById("show-results-button-div").innerHTML = "";
    document.getElementById("results").innerHTML = "";
    document.getElementById("licence-results").innerHTML = "";
    $35da740d59af89ba$var$changeSearchLabel(false);
}
function $35da740d59af89ba$var$changeSearchLabel(change = true) {
    const searchLabel = document.getElementById("search-label");
    if (change) searchLabel.innerText = "Check if your address is in a ward with selective licensing.";
    else searchLabel.innerText = "Search if your address needs a selective licence.";
}
// Create a variable for the postcode. 
let $35da740d59af89ba$var$postcode = document.getElementById('postcode');
//Enter key listener that calls the GetAddressesviaPoxy function
$35da740d59af89ba$var$postcode.addEventListener('keyup', (e)=>{
    if (e.key == 'Enter') $35da740d59af89ba$var$GetAddressesViaProxy();
    if (e.target.value === '') $35da740d59af89ba$var$clearElements();
});
//eventlistener for the button
document.getElementById("search").addEventListener("click", $35da740d59af89ba$var$GetAddressesViaProxy);
//listener for the clear x in the input
$35da740d59af89ba$var$postcode.addEventListener("search", (e)=>{
    $35da740d59af89ba$var$clearElements();
});
function $35da740d59af89ba$var$GetAddressesViaProxy() {
    $35da740d59af89ba$var$clearElements();
    $35da740d59af89ba$var$changeSearchLabel();
    document.getElementById("addresses").innerHTML = '<p class="loading-text"> Loading addresses...</p>';
    document.getElementById("addresses").scrollIntoView({
        block: "nearest"
    });
    //Get the postcode value
    let postcode_input = document.getElementById("postcode").value;
    //test against postcode regex
    let postcode_regex = new RegExp("^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$");
    let isPostcode = postcode_regex.test(postcode_input);
    let results = null;
    if (!postcode_input) document.getElementById("error_message").innerHTML = "Please enter some text in the location search.";
    else {
        //prepare query to send to the API, depending if we ave got a postcode or not
        let APIQueryString = '';
        if (isPostcode) {
            APIQueryString = `${"https://zwb5f0hl7b.execute-api.us-east-1.amazonaws.com/production/address-v2-proxy"}?format=detailed&postcode=${postcode_input}`;
            // console.log('is postcode', isPostcode);
            //First call to get the list of addresses from a postcode
            fetch(APIQueryString, {
                method: "get"
            }).then((response1)=>response1.json()).then((data)=>{
                // console.log('DATA',data);
                //Get API error messages if the UPRN values are not right
                if (data.data.errors) $35da740d59af89ba$var$clearElements(response.data.errors[0].message);
                else {
                    results = data.data.data.address;
                    let pageCount = data.data.data.pageCount;
                    //If there are no results, the postcode is not right. 
                    if (results.length === 0) $35da740d59af89ba$var$clearElements("No Hackney location found. Please amend your search.");
                    else {
                        //If there are results from the addresses proxy, we list them. 
                        //first, replace list element with a clone of itself, in order to remove previous listeners
                        //let listElement = document.getElementById("addresses");
                        document.getElementById("addresses").replaceWith(document.getElementById("addresses").cloneNode(true));
                        //now fill the list
                        document.getElementById("addresses").innerHTML = "<div class='govuk-form-group lbh-form-group'><select class='govuk-select govuk-!-width-full lbh-select' id='selectedAddress' name='selectedAddress'>";
                        document.getElementById("selectedAddress").innerHTML = "<option disabled selected value> Select a location from the list </option>";
                        for(let index = 0; index < results.length; ++index)//if (results[index].addressStatus == 'Approved' && (results[index].usagePrimary == 'Commercial' || results[index].usagePrimary == 'Dual Use')){
                        if (results[index].commercialOccupier) document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].commercialOccupier + " - " + results[index].singleLineAddress + "</option>";
                        else document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].singleLineAddress + "</option>";
                        //load more pages of results if needed       
                        if (pageCount > 1) for(let pgindex = 2; pgindex <= pageCount; ++pgindex)$35da740d59af89ba$var$loadAddressAPIPageViaProxy(APIQueryString, postcode_input, pgindex);
                        //close list of addresses
                        document.getElementById("addresses").innerHTML += "</select></div>";
                        //capture the change event - when an address is selected - we load the list of results using the UPRN selected. 
                        document.getElementById("addresses").addEventListener('change', (event)=>{
                            //get the selected UPRN and address details from the list of addresses
                            let selectedAddressDetails = document.querySelector('#selectedAddress').value.split('/');
                            let selectedWard = selectedAddressDetails[3];
                            $35da740d59af89ba$var$loadRegisterInfo(selectedWard);
                            document.getElementById("results").innerHTML = "";
                        });
                        window.scrollBy(0, 50);
                    }
                }
            }).catch((error)=>{
                console.log(error);
                document.getElementById("error_message").innerHTML = "Sorry, an error occured while retrieving locations";
                document.getElementById("addresses").innerHTML = '';
            });
        } else {
            // APIQueryString = `${process.env.ADDRESSES_API_PROXY_PROD}?format=detailed&usage_code=C,X,LP02&query=${postcode_input}`;
            document.getElementById("error_message").innerHTML = "Please enter a valid postcode";
            document.getElementById("addresses").innerHTML = '';
        }
    }
}
//function to add one page of results to the options list
function $35da740d59af89ba$var$loadAddressAPIPageViaProxy(APIQueryString, postcode_input, pg) {
    let results = null;
    let full_address = null;
    let UPRN = null;
    fetch(APIQueryString + `&page=${pg}`, {
        method: "get"
    }).then((response1)=>response1.json()).then((data)=>{
        results = data.data.data.address;
        for(let index = 0; index < results.length; ++index)//if (results[index].addressStatus == 'Approved' && (results[index].usagePrimary == 'Commercial' || results[index].usagePrimary == 'Dual Use')){
        if (results[index].commercialOccupier) document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].commercialOccupier + " - " + results[index].singleLineAddress + "</option>";
        else document.getElementById("selectedAddress").innerHTML += "<option value='" + results[index].UPRN + "/" + results[index].singleLineAddress + "/" + results[index].usageDescription + "/" + results[index].ward + "'>" + results[index].singleLineAddress + "</option>";
    });
}
function $35da740d59af89ba$var$loadRegisterInfo(selectedWard) {
    const selectiveLicenceWards = [
        "Hoxton East and Shoreditch",
        "Hoxton West",
        "Haggerston",
        "Woodberry Down",
        "Hoxton East & Shoreditch"
    ];
    let isNotSelectiveLicenceWard = selectiveLicenceWards.includes(selectedWard);
    // console.log("isNotSelectiveLicenceWard",isNotSelectiveLicenceWard);
    //Selective Licence || NOT REQUIRED ON THIS APP - TRANSFERED TO STANDALONE APP
    let textSection = `<p class="lbh-body">
    ${!isNotSelectiveLicenceWard ? 'Your property is in a ward with selective licensing. You might need a selective licence - it depends on who lives in the property.' : 'Your property is not in a ward with selective licensing. Check if you need an additional or mandatory licence instead.'}
  </p>`;
    document.getElementById('licence-results').innerHTML = textSection;
    document.getElementById("licence-results").scrollIntoView({
        block: "nearest"
    });
}


//# sourceMappingURL=lbh-licensing-register-selective-licence-lookup.483209bf.js.map
